import styled from 'styled-components'

export const ContactContainer = styled.div`
  max-width: 1316px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 3rem;
  margin: 0 auto;

  @media only screen and (max-width: 1366px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  @media only screen and (max-width: 900px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`

export const TextContainer = styled.div`
  min-width: 36%;
  color: var(--grey8);

  h1 {
    font-size: 40px;
    font-weight: 700;
  }

  @media only screen and (max-width: 900px) {
    margin-top: 120px;

    h1 {
      font-size: 20px;
      font-weight: 600;
    }
  }

  span,
  p {
    &.contact {
      font-size: 16px;
      font-weight: 500;
    }

    &.material-icons-round {
      font-size: 30px;
      color: var(--blue);
      margin-right: 1rem;
    }
  }

  img.material-icons {
    width: 30px;
    margin-right: 1rem;
    filter: invert(24%) sepia(33%) saturate(6510%) hue-rotate(243deg)
      brightness(96%) contrast(89%);
  }

  & > *:not(:last-child) {
    margin-bottom: 2.5rem;
  }

  @media only screen and (max-width: 900px) {
    width: 100%;

    p.contact {
      font-size: 14px;
    }

    .material-icons,
    .material-icons-round {
    }
  }
`
